// import React, { useState } from "react";
// import {
//   NewTable,
//   Button,
//   FormFieldSet,
//   PageHeader,
//   PageTitle,
//   Modal,
//   useFormHandler,
// } from "../../../../../components";

// const Deduction = () => {
//   // Form handler for add deduction modal
//   const { formData, errors, handleChange, resetForm } = useFormHandler({
//     deductionName: "",
//     deductionType: "Pre-Tax",
//     paymentPlan: "Recurring",
//     amount: "",
//     comments: "",
//   });

//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [deductions, setDeductions] = useState([
//     {
//       id: 1,
//       deductionName: "Health Insurance",
//       deductionType: "Fixed",
//       paymentPlan: "Monthly",
//       amount: "500",
//       recoveredAmount: "200",
//       balanceAmount: "300",
//       waivedAmount: "0",
//       comments: "Pending approval",
//     },
//     {
//       id: 2,
//       deductionName: "Loan Repayment",
//       deductionType: "Installment",
//       paymentPlan: "Quarterly",
//       amount: "1200",
//       recoveredAmount: "800",
//       balanceAmount: "400",
//       waivedAmount: "0",
//       comments: "In process",
//     },
//   ]);

//   const advancePaymentsColumns = [
//     { key: "deductionName", label: "Deduction Name" },
//     { key: "deductionType", label: "Deduction Type" },
//     { key: "paymentPlan", label: "Payment Plan" },
//     { key: "amount", label: "Amount" },
//     { key: "recoveredAmount", label: "Recovered Amount" },
//     { key: "balanceAmount", label: "Balance Amount" },
//     { key: "waivedAmount", label: "Waived Amount" },
//     { key: "comments", label: "Comments" },
//     {
//       key: "actions",
//       label: "Actions",
//       render: (row) => (
//         <div className="flex gap-2">
//           <Button
//             title="Stop Deduction"
//             color="success"
//             variant="outlined"
//             size="xs"
//           />
//         </div>
//       ),
//     },
//   ];

//   const handleAddDeduction = () => {
//     const newDeduction = {
//       id: Date.now(),
//       deductionName: formData.deductionName,
//       deductionType:
//         formData.deductionType === "Pre-Tax"
//           ? "Pre-Tax Deduction"
//           : "Post-Tax Deduction",
//       paymentPlan:
//         formData.paymentPlan === "Recurring"
//           ? "Recurring until stopped"
//           : "Installment plan",
//       amount: formData.amount,
//       recoveredAmount: "0",
//       balanceAmount: formData.amount,
//       waivedAmount: "0",
//       comments: formData.comments,
//     };

//     setDeductions([...deductions, newDeduction]);
//     resetForm();
//     setIsModalOpen(false);
//   };

//   return (
//     <div className="bg-white mb-8 p-4">
//       <PageHeader
//         RightSection={
//           <Button
//             title="+ Add Deduction"
//             variant="contained"
//             color="black"
//             onClick={() => setIsModalOpen(true)}
//           />
//         }
//       />

//       <div className="relative">
//         <div className="mt-4">
//           <NewTable
//             columns={advancePaymentsColumns}
//             rows={deductions}
//             hideToolBar
//           />
//         </div>

//         {/* Modal positioned directly under the table */}
//         {isModalOpen && (
//           <div className="w-full border border-gray-200 rounded-b-lg shadow-lg mt-[-1px]">
//             <div className="bg-white p-4">
//               <div className="flex justify-between items-center mb-4"></div>

//               <div className="grid grid-cols-3 gap-x-8 gap-y-6 max-w-7xl mt-4">
//                 <FormFieldSet
//                   type="text"
//                   title="Deduction Name"
//                   placeholder="Enter deduction name"
//                   value={formData.deductionName}
//                   onChange={(value) => handleChange("deductionName", value)}
//                   error={errors.deductionName}
//                   required
//                 />
//                 <FormFieldSet
//                   type="text"
//                   title="Deduction amount"
//                   placeholder="Enter deduction name"
//                   value={formData.deductionName}
//                   onChange={(value) => handleChange("deductionName", value)}
//                   error={errors.deductionName}
//                   required
//                 />
//               </div>
//               <div className="flex max-w-7xl mt-6">
//                 <div className="flex-1">
//                   <FormFieldSet
//                     type="radio"
//                     title="Deduction Type"
//                     options={[
//                       { value: "Pre-Tax", label: "Pre-Tax Deduction" },
//                       { value: "Post-Tax", label: "Post-Tax Deduction" },
//                     ]}
//                     value={formData.deductionType}
//                     name="deductionType"
//                     onChange={(event) =>
//                       handleChange("deductionType", event.target.value)
//                     }
//                     error={errors.deductionType}
//                   />
//                 </div>
//                 <div className="flex-1">
//                   <FormFieldSet
//                     type="radio"
//                     title="Deduction Type"
//                     options={[
//                       { value: "None", label: "Not to Deduct" },
//                       { value: "Installment", label: "Installment plan" },
//                       {
//                         value: "Recurring",
//                         label: "Total amount recurring until stopped",
//                       },
//                     ]}
//                     value={formData.paymentPlan}
//                     name="paymentPlan"
//                     onChange={(event) =>
//                       handleChange("paymentPlan", event.target.value)
//                     }
//                     error={errors.paymentPlan}
//                   />
//                 </div>
//               </div>
//               <div className="grid grid-cols-3 gap-x-8 gap-y-6 max-w-7xl mt-4">
//                 <FormFieldSet
//                   type="textArea"
//                   title="Connection (Comments)"
//                   placeholder="Enter any comments"
//                   value={formData.comments}
//                   onChange={(value) => handleChange("comments", value)}
//                   rows={3}
//                 />{" "}
//               </div>
//               <div className="flex mt-4 gap-x-2">
//                 <Button
//                   title="Cancel"
//                   variant="outlined"
//                   onClick={() => {
//                     setIsModalOpen(false);
//                     resetForm();
//                   }}
//                 />
//                 <Button
//                   title="Save"
//                   variant="contained"
//                   color="primary"
//                   onClick={handleAddDeduction}
//                 />
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default Deduction;

import React, { useEffect, useState } from "react";
import {
  NewTable,
  Button,
  FormFieldSet,
  PageHeader,
  PageTitle,
  Modal,
  useFormHandler,
  InfoTimeCard,
  StatusTags,
  NewTableAdv,
  ActivityCalendar,
  Backdrop,
  LogoLoader,
  showToast,
  DevNote,
  SmartTooltip,
} from "../../../../../components";
// import { deductionsrowdata } from "../../../../../assets/data/candidatesData"; // omkar commented this vite issue
import { mapTableRows } from "../../../../../utils";
import ActivitiesModal from "./Modals/ActivitiesModal";
import StopDeductionModal from "./Modals/StopDeductionModal ";
import AddDeductions from "./Deduction/Modals/AddDeductions";
import ReceivePayments from "./Deduction/Modals/ReceivePayments";
import CautionAmount from "./Deduction/Modals/CautionAmount";
import CollapseFromComponent from "./Deduction/CollapseFromComponent";
import ActivityModal from "./Deduction/Modals/ActivityModal";
import { totalCountStart } from "../../../../../redux/slices/totalCount/totalCountSlice";
import { usePagination } from "../../../../../hooks";
import { useDispatch, useSelector } from "react-redux";
import { getAllEmpDeductions } from "../../../../../redux/slices/payroll/payrollSlice";
import { deductionoprtions } from "../../../../../assets/data/projectData";
import { empRecieveSelectDeductionsStart } from "../../../../../redux/slices/employee/employeeSlice";
import common from "../../../../../utils/common";
import { formatCurrency } from "../../../../../utils/stringUtils";
import DeductionDetails from "./Deduction/DeductionDetails";
const Deduction = ({ setActiveTab }) => {
  const dispatch = useDispatch();
  const { updateDeductionsData } = common;
  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => {
      // dispatch(getAccountPayablesStart({ page: newPage, limit: newLimit }));
    },
  );
  const { value } = useSelector((state) => state.totalCount);
  const {
    employeeProfileUiid,
    currentEmployee: { employeeDetails, loadedTabs },
    error,
    employees,
  } = useSelector((state) => state.employee);
  const { loading, empDeduction } = useSelector((state) => state.payRoll);
  const totalCount = value?.empdeductions?.data || 0;
  const isLoading = !!loading;
  const empDeductions = empDeduction?.data || [];
  const [selectTypeDeduction, setSelectTypeDeduction] = useState(2);

  // states for deduction details page
  const [showDetails, setShowDetails] = useState(false);
  const [selectedDeduction, setSelectedDeduction] = useState(null);

  // Form handler for add deduction modal
  const { formData, errors, handleChange, resetForm } = useFormHandler({
    deductionName: "",
    deductionamount: "",
    deductionType: "Pre-Tax",
    paymentPlan: "Recurring",
    amount: "",
    comments: "",
    installmentCountNumber: "",
    deductionNamehidden: "",
  });
  const [isStopDeductionModal, setIsStopDeductionModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [isActivitiesModal, setISActivitiesModal] = useState(false);
  const [activeDeduction, setActiveDeduction] = useState(false);
  const [receicePayent, setReceicePayent] = useState(false);
  const [cautionAmount, setCautionAmount] = useState(false);

  const tableData = [
    {
      id: 1,
      deductionName: "Health Insurance",
      deductionType: "Fixed",
      installments: "9/10",
      amount: "500",
      recoveredAmount: "300",
      balanceAmount: "200",
      waivedAmount: "0.00",
      comments: "pendingApproval",
    },
    {
      id: 2,
      deductionName: "Loan RePayment",
      deductionType: "Installment",
      installments: "9/10",
      amount: "500",
      recoveredAmount: "300",
      balanceAmount: "200",
      waivedAmount: "0.00",
      comments: "In Process",
    },
  ];

  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleClickStopButton = async (row) => {
    try {
      // if (!row?.stop) {
      //   const isLinkedWithAnyPayroll = row?.installments
      //     ?.filter((i) => i?.payrollId?.status)
      //     ?.some((data) => data?.payrollId?.status !== 4);
      //   if (isLinkedWithAnyPayroll) {
      //     showToast("Deduction is linked to an active payroll. Unlink to take action!", "warning", 10000);
      //     return;
      //   }
      // }
      const payload = {
        coll: "EmpDeduction",
        uiid: row?.uiid,
        ...(!row?.stop && { preActions: ["ToggleStop"] }),
        payload: [
          {
            type: "SET",
            value: {
              stop: !row?.stop,
            },
          },
        ],
      };

      const response = await updateDeductionsData(payload);
      if (response?.success) {
        showToast(
          `Deduction - ${row.name} ${row.stop ? "stopped" : "started"}!`,
          "success",
        );
        await fetchDeductionDeatils();
      } else {
        console.error({ response });
        let errorMessage = response?.error;
        showToast(
          errorMessage
            ? errorMessage
            : `Failed to ${row.stop ? "stop" : "start"} deduction - ${row.name}`,
          "error",
        );
      }
    } catch (error) {
      console.error("Update error:", error);
      showToast(
        `Failed to ${row.stop ? "stop" : "start"} deduction - ${row.name}`,
        "error",
      );
    }
  };

  const advancePaymentsColumns = [
    {
      key: "name",
      label: "Deduction Name",
      showAccordianBtn: true,
      width: "min-w-[150px] max-w-[200px]",
      render: (row) => (
        <SmartTooltip
          description={row?.name}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div
            className="line-clamp-1! cursor-pointer text-info-500
            "
            onClick={() => {
              setSelectedDeduction(row);
              setShowDetails(true);
            }}
          >
            {row?.name}
          </div>
        </SmartTooltip>
      ),
    },
    {
      key: "type",
      label: "Deduction Type",
      width: "180px",
      render: (row) => {
        // Find the label in the options list that matches the row's type
        const findLabel =
          deductionoprtions.find((data) => data?.value === row?.deductionType)
            ?.label || "";

        // Return it wrapped in a styled span
        return <span className="text-info cursor-pointer">{findLabel}</span>;
      },
    },
    {
      key: "installmen",
      label: "Installments",
      width: "200px",
      render: (row) => <div>{row?.installments?.length}</div>,
    },
    {
      key: "amount",
      label: "Amount",
      width: "200px",
      render: (row) => {
        return <div>{formatCurrency(row?.amounts?.deducted)}</div>;
      },
    },
    {
      key: "recoveredAmount",
      label: "Recovered Amount",
      width: "200px",
      render: (row) => (
        <div>
          {/* {formatCurrency(
            row?.installments?.reduce(
              (acc, elem) => (acc += elem.received || 0),
              0
            ) || 0
          )} */}
          {formatCurrency(row?.amounts?.received)}
        </div>
      ),
    },
    {
      key: "balanceAmount",
      label: "Balance Amount",
      width: "200px",
      render: (row) => (
        <div>
          {/* {formatCurrency(
            row?.installments?.reduce(
              (acc, elem) => (acc += elem.receivable - (elem.received || 0)),
              0
            ) || 0
          )} */}
          {formatCurrency(
            (row?.amounts?.deducted || 0) - (row?.amounts?.received || 0),
          )}
        </div>
      ),
    },
    {
      key: "waivedAmount",
      label: "Waived Amount",
      width: "200px",
      render: (row) => <div>{formatCurrency(row?.amounts?.waived || 0)}</div>,
    },
    {
      key: "comments",
      label: "Comments",
      width: "200px",
      render: (row) => (
        <SmartTooltip
          description={row?.comments}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1 text-wrap">{row?.comments}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "actions",
      label: "Actions",
      render: (row) => (
        <div className="flex gap-2">
          <Button
            title={`${row?.stop ? "Start" : "Stop"} Deduction`}
            color={row?.stop ? "success" : "danger"}
            size="sm"
            onClick={() => handleClickStopButton(row)}
          />

          {/* <StatusTags size="xs" tag="Stop Deduction" /> */}
        </div>
      ),
      width: "180px",
    },
  ];
  const mappedRows = mapTableRows(empDeductions, advancePaymentsColumns);
  const fetchDeductionDeatils = async () => {
    const filters = {
      type: { type: "NONE", value: 1 },
      employeeId: { type: "NONE", value: employeeProfileUiid },
    };

    dispatch(
      totalCountStart({
        collection: "empdeductions",
        coll: "EmpDeduction",
        tname: "empdeductions",
        filters,
      }),
    );
    dispatch(
      getAllEmpDeductions({
        coll: "EmpDeduction",
        limit,
        page,
        filters,
        ref: "Payroll",
        incl: ["status"],
      }),
    );
  };
  useEffect(() => {
    fetchDeductionDeatils();
  }, [dispatch, page, limit]);
  return (
    <div>
      {showDetails ? (
        <DeductionDetails
          data={selectedDeduction}
          onBack={() => setShowDetails(false)}
        />
      ) : (
        <div>
          <DevNote>
            <>
              <Button
                icon={"refresh"}
                onClick={fetchDeductionDeatils}
                title={"Refresh"}
                variant="outlined"
              />
            </>
          </DevNote>
          <div>
            <div className="mt-4">
              <NewTableAdv
                columns={advancePaymentsColumns}
                rows={mappedRows}
                serverPagination={true}
                totalCount={totalCount}
                toolbarRight={{
                  search: true,
                  add: [
                    {
                      component: (
                        <Button
                          title="Add Deductions"
                          icon={"Add"}
                          color="primary"
                          size="sm"
                          onClick={() => {
                            dispatch(empRecieveSelectDeductionsStart([]));
                            setActiveDeduction(true);
                          }}
                        />
                      ),
                    },
                    {
                      component: (
                        <Button
                          title="Receive Payment"
                          color="primary"
                          size="sm"
                          onClick={() => {
                            dispatch(empRecieveSelectDeductionsStart([]));
                            setReceicePayent(true);
                            setSelectTypeDeduction(2);
                          }}
                        />
                      ),
                    },
                    {
                      component: (
                        <Button
                          title="Caution Amount"
                          color="primary"
                          size="sm"
                          onClick={() => {
                            dispatch(empRecieveSelectDeductionsStart([]));
                            setReceicePayent(true);
                            setSelectTypeDeduction(3);
                          }}
                        />
                      ),
                    },
                  ],
                }}
                accrodian={
                  <CollapseFromComponent
                    uniqueId={tableData.id}
                    rowData={mappedRows}
                    setActiveTab={setActiveTab}
                  />
                }
                // rowClickeble
                page={page}
                limit={limit}
                onPageChange={setPage}
                onLimitChange={handleLimitChange}
              />
            </div>

            <div>
              <StopDeductionModal
                open={isStopDeductionModal}
                onClose={() => setIsStopDeductionModal(!isStopDeductionModal)}
                row={selectedRow}
              />
            </div>

            <div className="mt-10">
              <div className="flex items-center justify-between">
                <p>ACTIVITIES</p>
              </div>
              <hr className="border-t border-gray-300 mt-2" />
              <div className="flex justify-center mt-6">
                <Button
                  title="Activities"
                  color="primary"
                  onClick={() => setISActivitiesModal(true)}
                />
              </div>
            </div>
            <AddDeductions
              isOpen={activeDeduction}
              onClose={() => setActiveDeduction(false)}
              fetchDeductionDeatils={fetchDeductionDeatils}
            />
            {console.log("empDeductions", empDeductions)}
            <ReceivePayments
              isOpen={receicePayent}
              onClose={() => setReceicePayent(false)}
              setActiveTab={setActiveTab}
              shouldMoveTab={true}
              empDeductions={empDeductions}
              type={selectTypeDeduction}
              callFunction={fetchDeductionDeatils}
              kpiLoadingPendingBal={loading}
              customerPendingBalance={
                empDeductions
                  ?.flatMap((item) =>
                    !item?.name?.match(/Health Insurance/i)
                      ? item?.installments
                      : [],
                  )
                  ?.reduce(
                    (acc, elem) =>
                      (acc += elem?.receivable - (elem?.received || 0)),
                    0,
                  ) || 0
              }
            />
            {/* <CautionAmount
          isOpen={cautionAmount}
          onClose={() => setCautionAmount(false)}
        /> */}
          </div>
          {/* <div>
        <CollapseFromComponent />
      </div> */}
          <ActivityModal
            isOpen={isActivitiesModal}
            onClose={() => setISActivitiesModal(false)}
          />
          <Backdrop isOpen={isLoading}>
            <LogoLoader />
          </Backdrop>
        </div>
      )}
    </div>
  );
};

export default Deduction;
